import * as React from 'react';
import {
    List,
    Datagrid,
    DateField,
    TextField,
    SearchInput,
    SelectInput,
    ReferenceInput,
    TextInput,
} from 'react-admin';
import { useMediaQuery, Theme } from '@mui/material';

import MobileGrid from './MobileGrid';

const entityFilters = [
    <SearchInput source="q" alwaysOn />,
    <TextInput source="id" />,
    <ReferenceInput source="city_id" reference="cities">
        <SelectInput optionText="title" fullWidth />
    </ReferenceInput>,
];

const EntityList = () => {
    const isXsmall = useMediaQuery<Theme>(theme =>
        theme.breakpoints.down('sm')
    );
    // const isSmall = useMediaQuery<Theme>(theme => theme.breakpoints.down('md'));
    return (
        // @ts-ignore
        <List
            filters={entityFilters}
            filter={{ city_id: '' }}
            sort={{ field: 'id', order: 'DESC' }}
            perPage={25}
        >
            {isXsmall ? (
                <MobileGrid />
            ) : (
                <Datagrid
                    optimized
                    rowClick="edit"
                    sx={{
                        '& .column-groups': {
                            md: { display: 'none' },
                            lg: { display: 'table-cell' },
                        },
                    }}
                >
                    <TextField source="id" />
                    <TextField source="city_id" />
                    <TextField source="city_entity.title" />
                    <DateField source="created" showTime={true} />
                    <DateField source="modified" showTime={true} />
                </Datagrid>
            )}
        </List>
    );
};

export default EntityList;
